import { render, staticRenderFns } from "./SendArrivalEmailModal.vue?vue&type=template&id=529b348a&scoped=true&lang=pug"
import script from "./SendArrivalEmailModal.vue?vue&type=script&lang=js"
export * from "./SendArrivalEmailModal.vue?vue&type=script&lang=js"
import style0 from "./SendArrivalEmailModal.vue?vue&type=style&index=0&id=529b348a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b348a",
  null
  
)

export default component.exports